import { IQuoteSection } from 'types/quote'
import CustomSelect from 'components/common/CustomSelect';
import CustomInput from 'components/common/CustomInput';
import { booleanSelect, currencySelect } from 'data/quote';
import AreaTitle from '../../AreaTitle';
import CreateArea from '../../CreateArea';
import CustomDatePicker from 'components/common/CustomDatePicker';
import { formatDate } from 'components/function';
import { useState } from 'react';

const Fourth = ({ quoteInfo, setQuoteInfo }: IQuoteSection) => {
    const [dateReset1, setDateReset1] = useState<boolean>(false)
    const [dateReset2, setDateReset2] = useState<boolean>(false)

    return (
        <AreaTitle title='선택정보 입력' step='03' zIndex='z-20'>
            <div className='flex flex-col gap-6 px-10 py-6'>
                <CreateArea title='선택 화물 정보' isStart>
                    <div className='flex flex-col flex-[1] gap-6 p-7.5 border-[#9D9EB7] border-1 rounded-lg max-w-[724px]'>
                        <div className='flex flex-col gap-3'>
                            <div className='flex gap-6 text-lg'>
                                <p className='flex-1'>
                                    {
                                        quoteInfo?.step1?.transportType === 'AIR' ? '희망 출발일' : '희망 출항일'
                                    }
                                </p>
                                <p className='flex-1'>
                                    {
                                        quoteInfo?.step1?.transportType === 'AIR' ? '희망 도착일' : '희망 입항일'
                                    }
                                </p>
                            </div>
                            <div className='flex gap-6'>
                                <div className='flex-[1] max-w-[320px]'>
                                    <CustomDatePicker
                                        height='10'
                                        isMinToday
                                        onChange={(value: Date | null | [Date | null, Date | null]) => {
                                            if (value instanceof Date && value !== null) {
                                                setQuoteInfo(p => ({
                                                    ...p,
                                                    step3: {
                                                        ...p.step3,
                                                        preferredDepartureDate: formatDate(value)
                                                    }
                                                }))
                                            }
                                            else if (value === null) {
                                                setDateReset1(true)
                                                setQuoteInfo(p => ({
                                                    ...p,
                                                    step3: {
                                                        ...p.step3,
                                                        preferredDepartureDate: ''
                                                    }
                                                }))
                                            }
                                        }}
                                        value={quoteInfo?.step3?.preferredDepartureDate}
                                        isReset={dateReset1}
                                        setIsReset={setDateReset1}
                                    />
                                </div>
                                <div className='flex-[1] max-w-[320px]'>
                                    <CustomDatePicker
                                        height='10'
                                        isMinToday
                                        onChange={(value: Date | null | [Date | null, Date | null]) => {
                                            if (value instanceof Date && value !== null) {
                                                setQuoteInfo(p => ({
                                                    ...p,
                                                    step3: {
                                                        ...p.step3,
                                                        preferredArrivalDate: formatDate(value)
                                                    }
                                                }))
                                            }
                                            else if (value === null) {
                                                setDateReset2(true)
                                                setQuoteInfo(p => ({
                                                    ...p,
                                                    step3: {
                                                        ...p.step3,
                                                        preferredArrivalDate: ''
                                                    }
                                                }))
                                            }
                                        }}
                                        value={quoteInfo?.step3?.preferredArrivalDate}
                                        isReset={dateReset2}
                                        setIsReset={setDateReset2}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className='flex flex-col gap-3'>
                            <p className='text-lg'>타겟 운임</p>
                            <div className='flex flex-[1] gap-6'>
                                <div className='flex-[1] max-w-[170px] shrink-0'>
                                    <CustomSelect
                                        height={40}
                                        fontSize={14}
                                        option={currencySelect}
                                        placeholder={'통화 선택'}
                                        defaultValue={
                                            quoteInfo?.step3?.currency !== undefined
                                                ? currencySelect.find(arr => arr.value === quoteInfo.step3.currency)
                                                : undefined
                                        }
                                        onChange={(value) => {
                                            setQuoteInfo(p => ({
                                                ...p,
                                                step3: {
                                                    ...p.step3,
                                                    currency: value
                                                }
                                            }))
                                        }}
                                    />
                                </div>
                                <div className='flex-[2]'>
                                    <CustomInput
                                        type="number" height={10} fontSize={'sm'} placeholder="숫자로 입력해주세요"
                                        value={String(quoteInfo.step3?.targetFreight) ?? ''}
                                        onChange={(e) => {
                                            setQuoteInfo(p => ({
                                                ...p,
                                                step3: {
                                                    ...p.step3,
                                                    targetFreight: Number(e.target.value)
                                                }
                                            }))
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        {
                            quoteInfo?.step1?.transportType === 'SEA' &&
                            quoteInfo?.step2.shipmentMode !== 'LCL' &&
                            <div className='flex flex-col gap-3'>
                                <div className='flex gap-6 text-lg'>
                                    <p className='flex-1 max-w-[170px] shrink-0'>타겟 선적지 프리타임</p>
                                    {
                                        quoteInfo.step3?.isOriginDnd &&
                                        <>
                                            <p className='flex-1'>Demurrage</p>
                                            <p className='flex-1'>Detention</p>
                                        </>
                                    }
                                </div>
                                <div className='flex gap-6'>
                                    <div className='flex-[1] max-w-[170px] shrink-0'>
                                        <CustomSelect
                                            height={40}
                                            fontSize={14}
                                            value={
                                                quoteInfo?.step3?.isOriginDnd !== undefined
                                                    ? booleanSelect.find(arr => arr.value === (quoteInfo.step3.isOriginDnd ? 'Y' : 'N'))
                                                    : null
                                            }
                                            option={booleanSelect}
                                            placeholder={'사용여부'}
                                            onChange={(value) => {
                                                setQuoteInfo(p => ({
                                                    ...p,
                                                    step3: {
                                                        ...p.step3,
                                                        isOriginDnd: value === 'Y' ? true : false,
                                                        originDemurrage: '',
                                                        originDetention: '',
                                                    }
                                                }))
                                            }}
                                        />
                                    </div>
                                    <div className='relative flex-[1] max-w-[320px]'>
                                        {
                                            quoteInfo.step3?.isOriginDnd &&
                                            <>
                                                <CustomInput
                                                    type="text"
                                                    height={10}
                                                    fontSize="sm"
                                                    placeholder="Demurrage"
                                                    value={quoteInfo.step3?.originDemurrage ?? ''}
                                                    maxLength={2}
                                                    onChange={(e) => {
                                                        let inputValue = e.target.value.replace(/[^0-9]/g, '');

                                                        if (inputValue === '0' || inputValue === '00') {
                                                            inputValue = '';
                                                        }

                                                        setQuoteInfo(p => ({
                                                            ...p,
                                                            step3: {
                                                                ...p.step3,
                                                                originDemurrage: inputValue
                                                            }
                                                        }));
                                                    }}
                                                />
                                                <div className='top-0 right-4 absolute flex justify-center items-center h-full text-primary pointer-events-none'>Day</div>
                                            </>
                                        }
                                    </div>
                                    <div className='relative flex-[1] max-w-[320px]'>
                                        {
                                            quoteInfo.step3?.isOriginDnd &&
                                            <>
                                                <CustomInput
                                                    type="text"
                                                    height={10}
                                                    fontSize="sm"
                                                    placeholder="Detention"
                                                    value={quoteInfo.step3?.originDetention ?? ''}
                                                    maxLength={2}
                                                    onChange={(e) => {
                                                        let inputValue = e.target.value.replace(/[^0-9]/g, '');

                                                        if (inputValue === '0' || inputValue === '00') {
                                                            inputValue = '';
                                                        }

                                                        setQuoteInfo(p => ({
                                                            ...p,
                                                            step3: {
                                                                ...p.step3,
                                                                originDetention: inputValue
                                                            }
                                                        }));
                                                    }}
                                                />
                                                <div className='top-0 right-4 absolute flex justify-center items-center h-full text-primary pointer-events-none'>Day</div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        }

                        {
                            quoteInfo?.step1?.transportType === 'SEA' &&
                            quoteInfo?.step2.shipmentMode !== 'LCL' &&
                            <div className='flex flex-col gap-3'>
                                <div className='flex gap-6 text-lg'>
                                    <p className='flex-1 max-w-[170px] shrink-0'>타겟 도착지 프리타임</p>
                                    {
                                        quoteInfo.step3?.isDestinationDnd &&
                                        <>
                                            <p className='flex-1'>Demurrage</p>
                                            <p className='flex-1'>Detention</p>
                                        </>
                                    }
                                </div>

                                <div className='flex gap-6'>
                                    <div className='flex-[1] max-w-[170px] shrink-0'>
                                        <CustomSelect
                                            height={40}
                                            fontSize={14}
                                            option={booleanSelect}
                                            value={
                                                quoteInfo?.step3?.isDestinationDnd !== undefined
                                                    ? booleanSelect.find(arr => arr.value === (quoteInfo.step3.isDestinationDnd ? 'Y' : 'N'))
                                                    : null
                                            }
                                            placeholder={'사용여부'}
                                            onChange={(value) => {
                                                setQuoteInfo(p => ({
                                                    ...p,
                                                    step3: {
                                                        ...p.step3,
                                                        isDestinationDnd: value === 'Y' ? true : false,
                                                        destinationDemurrage: '',
                                                        destinationDetention: '',
                                                    }
                                                }))
                                            }}
                                        />
                                    </div>
                                    <div className='relative flex-[1] max-w-[320px]'>
                                        {
                                            quoteInfo.step3?.isDestinationDnd &&
                                            <>
                                                <CustomInput
                                                    type="text"
                                                    height={10}
                                                    fontSize="sm"
                                                    placeholder="Demurrage"
                                                    value={quoteInfo.step3?.destinationDemurrage ?? ''}
                                                    maxLength={2}
                                                    onChange={(e) => {
                                                        let inputValue = e.target.value.replace(/[^0-9]/g, '');

                                                        if (inputValue === '0' || inputValue === '00') {
                                                            inputValue = '';
                                                        }

                                                        setQuoteInfo(p => ({
                                                            ...p,
                                                            step3: {
                                                                ...p.step3,
                                                                destinationDemurrage: inputValue
                                                            }
                                                        }));
                                                    }}
                                                />
                                                <div className='top-0 right-4 absolute flex justify-center items-center h-full text-primary pointer-events-none'>Day</div>
                                            </>
                                        }
                                    </div>
                                    <div className='relative flex-[1] max-w-[320px]'>
                                        {
                                            quoteInfo.step3?.isDestinationDnd &&
                                            <>
                                                <CustomInput
                                                    type="text"
                                                    height={10}
                                                    fontSize="sm"
                                                    placeholder="Detention"
                                                    value={quoteInfo.step3?.destinationDetention ?? ''}
                                                    maxLength={2}
                                                    onChange={(e) => {
                                                        let inputValue = e.target.value.replace(/[^0-9]/g, '');

                                                        if (inputValue === '0' || inputValue === '00') {
                                                            inputValue = '';
                                                        }

                                                        setQuoteInfo(p => ({
                                                            ...p,
                                                            step3: {
                                                                ...p.step3,
                                                                destinationDetention: inputValue
                                                            }
                                                        }));
                                                    }}
                                                />
                                                <div className='top-0 right-4 absolute flex justify-center items-center h-full text-primary pointer-events-none'>Day</div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                        <div className='flex flex-col gap-3'>
                            <div className='flex gap-6 text-lg'>
                                <p className='flex-1 max-w-[170px]'>통관 대행 여부</p>
                                <p className='flex-1 max-w-[170px]'>보험 대행 여부</p>
                            </div>
                            <div className='flex gap-6'>
                                <div className='flex-[1] max-w-[170px] shrink-0'>
                                    <CustomSelect
                                        height={40}
                                        fontSize={14}
                                        option={booleanSelect}
                                        defaultValue={
                                            quoteInfo?.step3?.clearanceRequired !== undefined
                                                ? booleanSelect.find(arr => arr.value === (quoteInfo.step3.clearanceRequired ? 'Y' : 'N'))
                                                : undefined
                                        }
                                        placeholder={'사용여부'}
                                        onChange={(value) => {
                                            setQuoteInfo(p => ({
                                                ...p,
                                                step3: {
                                                    ...p.step3,
                                                    clearanceRequired: value === 'Y' ? true : false
                                                }
                                            }))
                                        }}
                                    />
                                </div>
                                <div className='flex-[1] max-w-[170px] shrink-0'>
                                    <CustomSelect
                                        height={40}
                                        fontSize={14}
                                        option={booleanSelect}
                                        defaultValue={
                                            quoteInfo?.step3?.insuranceREquired !== undefined
                                                ? booleanSelect.find(arr => arr.value === (quoteInfo.step3.insuranceREquired ? 'Y' : 'N'))
                                                : undefined
                                        }
                                        placeholder={'사용여부'}
                                        onChange={(value) => {
                                            setQuoteInfo(p => ({
                                                ...p,
                                                step3: {
                                                    ...p.step3,
                                                    insuranceREquired: value === 'Y' ? true : false
                                                }
                                            }))
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </CreateArea>
                <CreateArea title='요청사항' isStart>
                    <textarea
                        className={`w-full h-full rounded-lg p-6 text-sm placeholder:text-[#9D9EB7] max-w-[724px] placeholder:font-normal bg-[#F8F8FA] hover:border-[#B3B3B3] border-1 resize-none`}
                        rows={6}
                        value={
                            !!quoteInfo?.step3?.description
                                ? quoteInfo.step3.description
                                : ''
                        }
                        placeholder="기타 세부 요청사항을 작성해 주시기 바랍니다. (500자 내외)"
                        onChange={(e) => {
                            setQuoteInfo(p => ({
                                ...p,
                                step3: {
                                    ...p.step3,
                                    description: e.target.value
                                }
                            }))
                        }}
                    >
                    </textarea>
                </CreateArea>
            </div>
        </AreaTitle>
    )
}

export default Fourth